import ActionIcon from '@/components/_common/ActionIcon';
import { usePurchaseDownloadXml } from '@/core/domain/purchase/Purchase.hooks';
import { useReportGenerate } from '@/hooks';
import { Popover } from 'antd';
import { DownloadCloud } from 'react-feather';

interface Props {
  purchaseId: number;
  hasXml: boolean;
  purchaseCode: number;
}

export default function PurchaseListActionDownloadXml({
  purchaseId,
  purchaseCode,
  hasXml,
}: Props) {
  const downloadXml = usePurchaseDownloadXml();

  const report = useReportGenerate();

  return (
    <Popover content="Baixar XML">
      <ActionIcon
        disabled={!hasXml || downloadXml.isLoading}
        onClick={async () => {
          const result = await downloadXml.mutateAsync(purchaseId);
          report.downloadFile({
            result,
            fileName: `compra-${purchaseCode}-${Number(new Date())}`,
            type: 'text/xml',
          });
        }}
      >
        <DownloadCloud size={20} />
      </ActionIcon>
    </Popover>
  );
}
